import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FulfillInventoryMoveRequestMutationVariables = Types.Exact<{
  input: Types.FulfillInventoryMoveRequestInput;
}>;


export type FulfillInventoryMoveRequestMutation = { readonly __typename?: 'Mutation', readonly fulfillInventoryMoveRequest: { readonly __typename?: 'InventoryMoveRequest', readonly id: string } };

export type RejectInventoryMoveRequestMutationVariables = Types.Exact<{
  input: Types.RejectInventoryMoveRequestInput;
}>;


export type RejectInventoryMoveRequestMutation = { readonly __typename?: 'Mutation', readonly rejectInventoryMoveRequest: { readonly __typename?: 'InventoryMoveRequest', readonly id: string } };


export const FulfillInventoryMoveRequestDocument = gql`
    mutation fulfillInventoryMoveRequest($input: FulfillInventoryMoveRequestInput!) {
  fulfillInventoryMoveRequest(input: $input) {
    id
  }
}
    `;
export type FulfillInventoryMoveRequestMutationFn = Apollo.MutationFunction<FulfillInventoryMoveRequestMutation, FulfillInventoryMoveRequestMutationVariables>;

/**
 * __useFulfillInventoryMoveRequestMutation__
 *
 * To run a mutation, you first call `useFulfillInventoryMoveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillInventoryMoveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillInventoryMoveRequestMutation, { data, loading, error }] = useFulfillInventoryMoveRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFulfillInventoryMoveRequestMutation(baseOptions?: Apollo.MutationHookOptions<FulfillInventoryMoveRequestMutation, FulfillInventoryMoveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FulfillInventoryMoveRequestMutation, FulfillInventoryMoveRequestMutationVariables>(FulfillInventoryMoveRequestDocument, options);
      }
export type FulfillInventoryMoveRequestMutationHookResult = ReturnType<typeof useFulfillInventoryMoveRequestMutation>;
export type FulfillInventoryMoveRequestMutationResult = Apollo.MutationResult<FulfillInventoryMoveRequestMutation>;
export type FulfillInventoryMoveRequestMutationOptions = Apollo.BaseMutationOptions<FulfillInventoryMoveRequestMutation, FulfillInventoryMoveRequestMutationVariables>;
export const RejectInventoryMoveRequestDocument = gql`
    mutation rejectInventoryMoveRequest($input: RejectInventoryMoveRequestInput!) {
  rejectInventoryMoveRequest(input: $input) {
    id
  }
}
    `;
export type RejectInventoryMoveRequestMutationFn = Apollo.MutationFunction<RejectInventoryMoveRequestMutation, RejectInventoryMoveRequestMutationVariables>;

/**
 * __useRejectInventoryMoveRequestMutation__
 *
 * To run a mutation, you first call `useRejectInventoryMoveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInventoryMoveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInventoryMoveRequestMutation, { data, loading, error }] = useRejectInventoryMoveRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectInventoryMoveRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectInventoryMoveRequestMutation, RejectInventoryMoveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectInventoryMoveRequestMutation, RejectInventoryMoveRequestMutationVariables>(RejectInventoryMoveRequestDocument, options);
      }
export type RejectInventoryMoveRequestMutationHookResult = ReturnType<typeof useRejectInventoryMoveRequestMutation>;
export type RejectInventoryMoveRequestMutationResult = Apollo.MutationResult<RejectInventoryMoveRequestMutation>;
export type RejectInventoryMoveRequestMutationOptions = Apollo.BaseMutationOptions<RejectInventoryMoveRequestMutation, RejectInventoryMoveRequestMutationVariables>;